import React from 'react';
import CardSpacer from './CardSpacer';
import { mapViewLayoutToComponents } from '../../helpers';
import {
  DashboardLayoutWrapper, Column, Row, EditLayoutButton,
} from './DashboardLayout.styles';

const ELEMENT_MAPPINGS = {
  row: { component: Row, requiredProps: ['height'] },
  column: { component: Column, requiredProps: ['width'] },
};

const DashboardLayout = (props) => {
  const {
    visualisations,
    layout,
    viewLayout,
    editing,
    toggleEditor,
  } = props;

  const mappingsWithBoxLayout = {
    ...ELEMENT_MAPPINGS,
    layoutBox: {
      requiredProps: ['controls', 'id', 'allowableVisualisationType'],
      component: CardSpacer,
      dependencyData: ({ id }) => {
        const userMeta = layout.dashboardItems
          .find(item => item.position === id) || { position: id };
        return {
          ...props,
          visualisation: {
            definition: visualisations[userMeta.visualisationType],
            userMeta,
          },
        };
      },
    },
  };

  const mappedViewLayout = mapViewLayoutToComponents(
    viewLayout.boxLayout,
    mappingsWithBoxLayout,
    layout.dashboardItems,
    visualisations,
  );

  return (
    <DashboardLayoutWrapper pl={editing ? 1 : 4} pr={1} py={1}>
      <EditLayoutButton
        color="greyscale.2"
        editorOpen={editing}
        onClick={toggleEditor}
        fontSize="5"
        m="2"
      />
      {mappedViewLayout}
    </DashboardLayoutWrapper>
  );
};

export default DashboardLayout;
